import readMoreByHeight from '../readMore';

const registerUpdatesStream = () => {
  readMoreByHeight(200, '.report-updates__update-content');
};

window.registerUpdatesStream = registerUpdatesStream;
